import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Loader } from '@grupa-pracuj/react-loader';

import Pagination from 'src/components/Pagination/PaginationWrapper';
import OfferTabsContainer from 'src/containers/OfferTabsContainer';
import OffersContainer from 'src/containers/OffersContainer';
import 'src/containers/PaginationContainer.scss';


class PaginationContainer extends PureComponent {
  renderLoader = () => (
    <div data-test="section-loader" styleName="offers__loader">
      <Loader />
    </div>
  );

  renderOffersContainer = activeTab => (
    <OffersContainer activeTab={ activeTab } />
  );

  render() {
    const { isProcessing, activeTab } = this.props;

    const yourActivityText = 'Twoja aktywność';

    return (
      <div data-test="section-your-offers" styleName="offers">
        <div styleName="offers__header">
          <h2 styleName="header__primary">{ yourActivityText }</h2>
        </div>

        <OfferTabsContainer />

        <Pagination activeTab={ activeTab }>
          { isProcessing ? this.renderLoader() : this.renderOffersContainer(activeTab) }
        </Pagination>
      </div>
    );
  }
}

PaginationContainer.propTypes = {
  activeTab: PropTypes.string.isRequired,
  isProcessing: PropTypes.bool.isRequired
};

const mapStateToProperties = state => ({
  activeTab: state.tabsReducer.activeTab,
  isProcessing: state.offersReducer.processing
});

export default connect(mapStateToProperties)(PaginationContainer);
